<aside class="esn-contact-card">
  @if (heading() || description()) {
    <div class="esn-contact-card__heading">
      @if (heading()) {
        <h2 class="esn-contact-card__title">{{ heading() }}</h2>
      }
      @if (description()) {
        <p class="esn-contact-card__description">{{ description() }}</p>
      }
    </div>
  }

  @if (channels().length || facts().length) {
    <div class="esn-contact-card__contacts">
      @for (channel of channels(); track channel.label; let first = $first) {
        @if (!first) {
          <div class="esn-contact-card__divider" aria-hidden="true"></div>
        }
        <div class="esn-contact-card__channel">
          <span class="esn-contact-card__channel-label">{{ channel.label }}</span>
          @if (href(channel); as link) {
            <a class="esn-contact-card__channel-value" [href]="link">{{ channel.value }}</a>
          } @else {
            <span class="esn-contact-card__channel-value">{{ channel.value }}</span>
          }
          @if (channel.note) {
            <span class="esn-contact-card__channel-note">{{ channel.note }}</span>
          }
        </div>
      }
      @if (facts().length) {
        @if (channels().length) {
          <div class="esn-contact-card__divider" aria-hidden="true"></div>
        }
        <dl class="esn-contact-card__facts">
          @for (fact of facts(); track fact.label) {
            <div class="esn-contact-card__fact">
              <dt class="esn-contact-card__fact-label">{{ fact.label }}</dt>
              <dd class="esn-contact-card__fact-value">{{ fact.value }}</dd>
            </div>
          }
        </dl>
      }
    </div>
  }

  @if (tourLabel()) {
    <div class="esn-contact-card__divider" aria-hidden="true"></div>
    <div class="esn-contact-card__tour">
      @if (tourText()) {
        <p class="esn-contact-card__tour-text">{{ tourText() }}</p>
      }
      <esn-button class="esn-contact-card__tour-button" variant="outline" (clicked)="tourRequested.emit()">
        {{ tourLabel() }}
      </esn-button>
    </div>
  }
</aside>
